export default __webpack_public_path__ + "static/media/Home-button-selected.58559aec.svg";